<template>
        <el-dialog :visible.sync="dialogVisible" title="复制当前数据到目标学校" custom-class="custom-dialog" :close-on-click-modal="false"
            @opened="dialogOpen" @closed="dialogClose" width="350px">

            <el-form ref="form"
                v-loading="loading"
                :element-loading-text = "loadingText"
                element-loading-background = "rgba(255, 255,255,0.7)"
                :model="form" 
                :rules="rules" 
                label-width="100px">
                <el-form-item   prop="targetSchoolId" label="目标学校">
                        <el-select v-model="form.targetSchoolId" clearable collapse-tags placeholder="请选择目标学校">
                        <el-option filterable
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible=false">取消</el-button>
                <el-button type="primary" @click="save()">确定</el-button>
            </span>    
    </el-dialog>
</template>
       
<script>
    import http from '../../../../common/http'; 

    export default {
        name: 'setEvaluateIndex',
        components: {},
        props: {
            value: Boolean,
            currSchoolId: {
                type: String,
                default() {
                    return ""
                }
            },
        },
        watch: {
            value(val) {
                this.dialogVisible = val
            },
            dialogVisible(val) {
                this.$emit('input', val)
            },
        },
        data(){
            return{
                dialogVisible:false,
                loading: false,
                loadingText: "",
                form:{
                    targetSchoolId:""
                },
                depts:[],
                rules: {
                    targetSchoolId: [
                        { required: true, message: '请选择目标学校', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        methods:{
            dialogOpen() {
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                this.getDeptData()
            },
            dialogClose(done){
                this.dialogVisible = false
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let msg="目标学校的数据将会被覆盖，是否继续？";
                        this.$commonFn.showConfirm2(msg,this.saveSuccess);
                    }
               });
            },
            saveSuccess(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.clockinTemplateCopyCurrDataToTargetSchoolUrl;
                        let data = {
                            currSchoolId: this.currSchoolId,
                            targetSchoolId: this.form.targetSchoolId
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.loading=true;
                        this.loadingText="复制中...";
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.dialogVisible=false;
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/task/components/setCopy.vue